import { render, staticRenderFns } from "./Vektorlogo.vue?vue&type=template&id=702acc6e&"
import script from "./Vektorlogo.vue?vue&type=script&lang=js&"
export * from "./Vektorlogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports